<template>
<form class="regForm j-loginform">
    <input type="hidden" id="fromUri" name="fromUri" value=""/>
    <input type="hidden" id="tip" name="tip" value=""/>
    <div class="regIcLt inl-b j-coutryarea">
        <div class="regSelBox regInput inl-b wid-120" :class="{'open': showCoutries}" @click.stop="toggleCoutries">
          <span class="wid-30 elli inl-b j-selected-name">{{coutry}}</span>
          <span class="regSelBtn" :data-code="code"><span class="j-selected-code">{{code}}</span><i class="iconfont icon-ic_down"></i></span>
          <div class="regListBox">
            <div class="regSelList" ref="regCodeList">
              <ul>
                <li v-for="(item, index) of coutries" @click="selectCoutry(item)">
                    <span class="fr regSelNum">{{item.code}}</span>
                    <span>{{item.name}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <div class="regIcLt inl-b fr">
        <input type="text" name="account" id="userAccount" v-model="user.account" class="regInput wid-170 pdl-50" placeholder="请输入您的账号/手机号/邮箱" @blur="checkAccount">
        <i class="iconfont icon-nickname"></i>
        <p class="regErrTex j-error" v-show="!verify.account && jerror.account">{{jerror.account}}</p>
    </div>
    <div class="regIcLt">
        <input type="password" name="password" id="userPwd" @keyup.enter="submit" v-model="user.password" class="regInput pdl-50 wid-300"  placeholder="请输入6-20位密码" @blur="checkPassword">
        <i class="iconfont icon-password"></i>
        <p class="regErrTex j-error" v-show="jerror.password && !verify.password">{{jerror.password}}</p>
    </div>

    <div class="regAgreeWrap">
        <input type="checkbox" v-model="user.rememberMe" id="xmlyReg" class="icon-checkbox" checked>
        <label for="xmlyReg" class="regCheckLab" @click="rememberLogin"><span class="checkIcon"></span>记住登录状态</label>
        <a href="/passport/user_info/show" @click="findPassword" class="c10 mgl-20">找回密码</a>
    </div>
    <div class="error" >&nbsp;</div>
    <a id="login_btn" class="regSubmit" :class="{'disabled': !canSubmit}" @click.stop.prevent="submit">登录</a>
</form>
</template>
<script>
import { queryHref } from '@/common/utils'
var gMsg = {
  userError: '账号格式不正确!',
  noUser: '该账号尚未注册!',
  pwdError: '该账号密码不正确!',
  userEmpty: '请输入账号!',
  pwdEmpty: '请输入密码!',
  pwdTooShort: '密码不能短于6位',
  pwdTooLong: '密码不能长于20位',
  sysError: '系统繁忙！',
  checkCodeEmpty: '请输入验证码'
}
import * as Ps from 'perfect-scrollbar'
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
import coutries from '@/coutries.js'
import validator from '@/common/validator'
import api from '@/api'
const pathPrefix = '/xmcaptcha-service'
export default {
  data () {
    return {
      coutries: coutries,
      showCoutries: false,
      code: '+86',
      coutry: '中国',
      user: {
        account: '',
        password: ''
      },
      jerror: {
        account: '',
        password: ''
      },
      verify: {
        account: false,
        password: false
      }
    }
  },
  computed: {
    canSubmit () {
      return this.verify.account && this.verify.password
    },
    toUrl () {
      return this.$store.state.toUrl
    }
  },
  watch: {
    'user.password' (pwd) {
      if (pwd.trim().length >= 6)
        this.checkPassword()
    }
  },
  methods: {
    toggleCoutries () {
      this.showCoutries = !this.showCoutries
    },
    selectCoutry (obj) {
      this.code = obj.code
      this.coutry = obj.name
      this.checkAccount()
    },
    closeList () {
      this.showCoutries = false
    },
    checkAccount () {
      this.verify.account = false
      var value = this.user.account.trim()
      if (!value) {
        this.jerror.account = gMsg.userEmpty
        return new Promise(resolve => resolve(false))
      }
      if (this.code === '+86' && !validator(value, 'email') && !validator(value, 'mobile')) {
        this.jerror.account = gMsg.userError
        return new Promise(resolve => resolve(false))
      }
      if (!validator(value, 'email') && this.code && this.code != '+86') {
        value = this.code.replace(/\+/, '') + '-' + value
      }

      return api.checkAccount({email: value}).then(res => {
        var result = res.data
        if (result.success) {
          this.verify.account = true
        } else {
          var msg = ''
          if (result.msg) {
            msg = result.msg
          }
          this.jerror.account = msg
        }
      }).catch(error => {
        this.jerror.account = gMsg.sysError
      })

    },
    checkPassword () {
      this.verify.password = false
      var value = this.user.password.trim()
      if (!value) {
        this.jerror.password = gMsg.pwdEmpty
        return false
      }
      var len = value.length
      if (len < 6) {
        this.jerror.password = gMsg.pwdTooShort
        return false
      }
      if (len > 20) {
        this.jerror.password = gMsg.pwdTooLong
        return false
      }
      this.verify.password = true
      return true
    },
    submit () {
      if (this.canSubmit) {
        //点击登录埋点
        xmLog && xmLog('pv.send', 'event', {
          currPage: "login",
          currPageId: null,
          currPageUrl: "/passport/login",
          item: "login",
          itemId:null,
          module: null,
          serviceId: "click",
        })

        this.user.account = this.user.account.trim()
        let account = this.user.account
        if (!validator(account, 'email') && this.code && this.code != '+86') {
          account = this.code.replace(/\+/, '') + '-' + account
        }
        let user = {
          account,
          password: this.user.password
        }
        api.submit(JSON.parse(JSON.stringify(user))).then(res => {
          if (res.data.success && !res.data.gotoBindMPhone && !res.data.gotoValidateMobile) {
            window.location.href = this.toUrl
          } else if (res.data.ret === 211 || res.data.ret === 212) {
            this.$store.commit('setCheckKey', res.data.checkKey)
            this.$store.commit('showImageCode')
            this.$store.commit('setCaptchaInfo', res.data.captchaInfo)
            api.getImageCodeInfo({ info: res.data.captchaInfo }).then(res => {
              const { background, token } = res.data
              this.$store.commit('setImageCodeURL', pathPrefix + background)
              this.$store.commit('setImageCodeToken', token)
            })
          } else if (res.data.gotoBindMPhone) {
            this.$store.commit('changeBindStatus', 'TO_BIND')
            this.$store.commit('setCheckKey', res.data.checkKey)
          } else if (res.data.gotoValidateMobile) {
            this.$store.commit('showSMSCode')
            this.$store.commit('setCheckKey', res.data.checkKey)
            this.$store.commit('setMobileReal', res.data.mobileReal)
            this.$store.commit('setMobileShow', res.data.mobileShow)
          } else {
            this.jerror.password = res.data.errorMsg
            this.verify.password = false
            this.user.password = ''
          }
        })
      }
    },
    findPassword(){
      //找回密码埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "findPassword",
        itemId:null,
        module: null,
        serviceId: "click",
      })
      _hmt.push(['_trackEvent', 'login_password', 'click'])
    },
    rememberLogin(){
      //记住登录状态埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "rememberLogin",
        itemId: !this.user.rememberMe,
        module: null,
        serviceId: "click",
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      Ps.initialize(this.$refs['regCodeList'], {
        minScrollbarLength: 3
      })
    })
    document.addEventListener('click', this.closeList)
    // this.$store.commit('changeBindStatus', 'TO_BIND')
  },
  destroyed () {
    document.removeEventListener('click', this.closeList)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/j-form.vue